import axios from 'axios';
import { toast } from 'react-toastify'
// Create an instance of axios with the base URL

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
  // baseURL: "https://civil.techbuild.tech/api/v1"
});

// Add a request interceptor to include the auth token in every request
api.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user')); // or use sessionStorage or another storage method
    //console.log(user.auth_token)
    const token = user?.auth_token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; // Add token to the Authorization header
    }
    return config;
  },
  (error) => {
    if (error.response && error.response.status === 403|| error.response.status===401) {
      // Optionally log the user out by removing the user from localStorage
      console.error(error)
      console.error('Access Forbidden: Unauthorized request.')
      localStorage.removeItem("user");
      localStorage.removeItem("access_token");
      localStorage.removeItem("AllFilesState");
      localStorage.removeItem("currentPath")
      localStorage.removeItem("avatarColor-1")
      // You can also redirect the user to the login page or show a message here
      window.location.href = '/login'; // Redirect to login page
    }
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Safely check if response exists before accessing .status
    const status = error.response?.status;

    if (status === 403 || status === 401) {
      console.error('Access Forbidden: Unauthorized request.');
      console.error(error);

      localStorage.removeItem('user');
      localStorage.removeItem("access_token");
      localStorage.removeItem("AllFilesState");
      localStorage.removeItem("currentPath");
      localStorage.removeItem("avatarColor-1");

      window.location.href = '/login';
      toast.error('Access denied.');
    }

    // Optional: better logging for ALL errors
    console.error('API Error:', {
      message: error.message,
      code: error.code,              // e.g. ERR_NETWORK, ERR_BAD_REQUEST
      response: error.response,      // may be undefined
      request: error.request,        // the request object if no response
      config: error.config
    });

    return Promise.reject(error);
  }
);
export const imageUrl = process.env.REACT_APP_IMAGEURL;

export const login = (data) => {
  const response = api.post('/users/login', data);
  return response;
};

export const getUsers = async () => {
  const response = await api.get('/users/getall');
  return response;
};

export const addUser = (data) => {
  const res = api.post('/users/insertUser', data);
  return res;
};

export const changeUserStatus = (id) => {
  const res = api.post(`/users/updateStatus/${id}`);
  return res;
};

export const deleteUser = (id) => {
  const res = api.delete(`/users/delete/${id}`);
  return res;
};

export const getSingleUser = (id) => {
  const res = api.post(`/users/findById/${id}`);
  return res;
};

export const getProjects = () => {
  const res = api.get('/project/getall');
  return res;
};
export const getSingleProject = (id) => {
  const res = api.post(`/project/getById/${id}`);
  return res;
}
export const addProject = (data) => {
  const res = api.post('/project/insertProject', data);
  return res;
};

export const getProjectNames = () => {
  const res = api.get('/project/getallProjectName');
  return res;
};

export const updateProject = ({ data, id }) => {
  const res = api.post(`/project/updateById/${id}`, data);
  return res;
};

export const updateUser = ({ data, id }) => {
  const res = api.post(`/users/updateById/${id}`, data);
  return res;
};

export const deleteProject = (id) => {
  const res = api.delete(`/project/delete/${id}`);
  return res;
};

export const addRFI = (data) => {
  const res = api.post('/reqforinfo/insertRfi', data);
  return res;
};

export const getRFI = (id) => {
  const res = api.post(`/reqforinfo/getAllRFIs`);
  return res;
};

export const updateRfi = (data, id) => {
  const res = api.post(`/reqforinfo/updateById/${id}`, data);
  return res;
};

export const getTask = (id) => {
  const res = api.get(`/task/getAll/${id}`);
  return res;
};

export const getProjectManager = () => {
  const res = api.get('users/projectManager');
  return res;
};

export const getClientManager = () => {
  const res = api.get('users/clientSideManager');
  return res;
};

export const assignTask = (data) => {
  const res = api.post('/task/insertTask', data);
  return res;
};

export const updateTask = ({ id, data }) => {
  const res = api.post(`/task/updateById/${id}`, data);
  return res;
};

export const deleteTask = (id) => {
  const res = api.delete(`/task/delete/${id}`);
  return res;
};

export const createFolder = async (data, project_id) => {
  console.log(data,project_id)

  const res = await api.post('/filesysytem/Folder', { projectId: project_id, requestedPath: data, });
  return res;
};
export const updateFolder=async (data, id) => {
  const res = await api.post(`/filesysytem/renameFolder`, data);
  return res;
}

export const getFolders = async (data) => {
  const res = await api.post('/filesysytem/getAllFolder',data);
  return res;
};

export const deleteFolder = (data) => {
  //console.log(data)
  const res = api.delete('/filesysytem/deleteFolder',{data});
  return res;
};

export const deleteFile = (data) => {
  console.log(data)
  const res = api.delete(`/filesysytem/deleteFile`,{data});
  return res;
};

export const getFiles = (data) => {
  const res = api.post(`/filesysytem/getAllFileWithLatestVersion`,data);
  return res;
};
export const editFile = (data)=> api.post('/filesysytem/addVersion',data)
export const renameFile = (data)=> api.post('/filesysytem/renameFile',data)

export const uploadFiles = (data) => {
//  console.log(data)
  const res = api.post(`/filesysytem/uploadFile`, data);
  return res;
};

export const changeStatus = async (projectId, status) => {
  try {
    const response = await api.post(`/project/updateStatus/${projectId}`, { status });
    return response.data;
  } catch (error) {
    console.error('Error updating status:', error);
    throw error;
  }
};

export const dashboardApi = (id) => {
  const res = api.post(`/users/dashboard/${id}`);
  return res;
};

export const addIssue = (data) => {
  //.log(data)
  const res = api.post('/issueTracker/insertIssue', data);
  return res;
}
export const changeIssueStatus = async (id) => {

  const res = await api.post('/issueTracker/updateStatus', { issue_id: id });
  //console.log(res)

  return res;
}
export const updateIssue = (data) => {
  const res = api.post('/issueTracker/updateById', data);
  return res;
}
export const viewIssues = () => {
  const res = api.post('/issueTracker/getall');
  return res;
}
//documents
export const getAllDocs = (id) => {
  const res = api.post('/filesysytem/gateFilesByProjectId', id);
  return res;
} 
export const getDocVersions=(data)=>api.post('/filesysytem/getAllFileWithVersion',data)
//alerts
// api/api.js
// api/api.js  (or wherever getAllAlerts lives)
export const getAllAlerts = () => api.get('/alert/getAll');
export const addAlert=(data)=>api.post('/alert/insertAlert',data)
export const updateAlert = ({ id, data }) => api.post(`/alert/updateById/${id}`, data)
export const getUserNotifications = (data) => api.post('/alert/user/notifications', data);
export const markNotificationAsRead = (id) => api.post(`/alert/user/notifications/${id}/read`);
export const markAllNotificationsAsRead = () => api.post('/alert/user/notifications/readAll');
export const deleteAlert=(id)=>api.delete(`/alert/deleteById/${id}`)              
//meeting
export const addMeeting=(data)=>api.post('/meeting/insertmeeting',data)
export const getAllMeeting=()=>api.post('/meeting/getall')
export const meetingStatus=(data)=>api.post('/meeting/updateStatus',data)
export const updateMeetinng=(data)=>api.post('/meeting/updateById',data)
//chats
export const seeComments=(data)=>api.post("/chat/getchat",data)
export const addComments=(data)=>api.post("/chat/insertMessage",data)
//teams
export const getAllTeams=(data)=>api.post("/team/getTeamName",data)
export const addTeam=(data)=>api.post("/team/insertteam",data)
export const getMember=(data)=>api.post("/team/getMembers",data)
export const allocatedMembers=(data)=>api.post("/team/allocatedMember",data)
export const deleteMember=(data)=>api.post("/team/RemoveMember",data)
export const getTeamDetails=(data)=>api.post("/team/getTeamDetails",data)
export const deleteTeam=(data)=>api.post(`/team/deleteTeam`,data)
export const allMembers=(data)=> api.post("/team/getAllMemberOfProjects", data);
//quality inspection
export const getAllQualityInspection=(data)=>api.post("/qualityInspection/getall",data)

export const addQualityInspection=(data)=>api.post("/qualityInspection/insert",data)
export const updateQualityInspection=(data)=>api.post("/qualityInspection/updateByID",data)
export const deleteQualityInspection=(id)=>api.delete(`/qualityInspection/deleteByID/${id}`)
export const updateQIStatus=(data)=>api.post("/qualityInspection/updateStatus",data)
//soil prediction
export const getAllSoilPrediction=(data)=>api.post("/soilPrediction/getall",data)
export const addSoilPrediction=(data)=>api.post("/soilPrediction/insert",data)
export const updateSoilPrediction=(data)=>api.post(`/soilPrediction/updateByID/${data.id}`,data)
export const deleteSoilPrediction=(data)=>api.post(`/soilPrediction/deleteById/${data}`)
export const updateSPStatus=(data)=>api.post("/soilPrediction/updateStatus",data)
//safety inspection
export const getAllSafetyInspection=(data)=>api.post("/safety/getall",data)
export const addSafetyInspection=(data)=>api.post("/safety/insert",data)
export const updateSafetyInspection=(data)=>api.post("/safety/updateByID",data)
export const deleteSafetyInspection = (id) => 
  api.delete(`/safety/deleteByID/${id}`);
//dangerPrediction
export const getAllDangerPrediction=(data)=>api.post("/dangerPrediction/getall",data)
export const addDangerPrediction=(data)=>api.post("/dangerPrediction/insert",data)
export const updateDangerPrediction = (id, formData) =>
  api.post(`/dangerPrediction/updateById/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
export const deleteDangerPrediction = (id) => 
  api.delete(`/dangerPrediction/deleteById/${id}`);
// export const deleteDangerPrediction=(id)=>api.delete(`/dangerPrediction/deleteByID/${id}`)

//section
export const getAllSection=(data)=>api.post("/section/getall",data)
export const addSection=(data)=>api.post("/section/insert",data)
export const updateSection=(data)=>api.post(`/section/updateByID/${data.id}`,data)
export const deleteSection=(data)=>api.post(`/section/deleteById/${data.id}`,data)
//structure
export const getAllStructure=(data)=>api.post("/structure/getAll",data)
export const addStructure=(data)=>api.post("/structure/insert",data)
export const deleteStructure=(data)=>api.post(`/structure/deleteByID/${data.id}`,data)

// File serving API to avoid CORS issues
export const getFileUrl = (data) => {
  const { projectId, folderPath, fileName, fileId } = data;
  const params = new URLSearchParams();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.auth_token || localStorage.getItem('access_token');
  
  if (fileId) {
    params.append('fileId', fileId);
  } else {
    params.append('projectId', projectId);
    params.append('folderPath', folderPath);
    params.append('fileName', fileName);
  }

  if (token) {
    params.append('token', token);
  }
  
  // Return the full URL for the file serving endpoint
  return `${process.env.REACT_APP_BASE_URL}/filesysytem/serveFile?${params.toString()}`;
};
